"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noRefinementChecks = void 0;
function noRefinementChecks(inputType) {
    return inputType;
}
exports.noRefinementChecks = noRefinementChecks;
//# sourceMappingURL=noRefinementChecks.js.map